import { get } from 'lodash-es';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { getPageLinksPath, LinkWidgetsModel } from 'client/data/models/link-widgets';
import { pageDefinition } from 'client/site-modules/shared/pages/page';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getFAQSchema } from 'client/seo/schemas/faq';
import { TMV_FAQ } from 'client/site-modules/editorial/constants/faqs';
import { setCriticalCss } from 'client/actions/critical-css';
import { getInitialTabIdFromLocation } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/utils/get-initial-tab-id-from-location';

import { Tmv, BREADCRUMBS } from './tmv';

export const pageDefinitionConfiguration = {
  name: 'tmv_index',
  category: 'tmv_index',
  component: Tmv,
  preload: store => {
    const {
      pageContext: { location, page },
    } = store.getState();
    const preloader = new ModelPreloader(store);

    preloader.resolve(getPageLinksPath(), LinkWidgetsModel);

    return preloader.load().then(() => {
      const initialTabId = getInitialTabIdFromLocation({
        location,
        isLicensePlateTabDefault: false,
        isSellCar: false,
        referer: page?.referer,
      });

      store.dispatch(
        setCriticalCss({
          initialTabId, // 3 values
        })
      );
    });
  },
  seo: (state, props) => ({
    title: 'Edmunds TMV - True Market Value / Car Value',
    keywords: 'TMV, True Market Value, Used Cars, Edmunds',
    description:
      'Edmunds True Market Value (TMV®) pricing tool delivers true car value, allowing you to identify fair market value on a new or used car and get a great deal. Based on actual sales data, TMV is a guide to what other people in your area paid for the same car.',
    jsonld: [
      getBreadcrumbSchema(BREADCRUMBS),
      getFAQSchema({
        entries: TMV_FAQ,
        generateLearnMoreLinks: true,
        pathname: get(props, ['location', 'pathname'], ''),
      }),
    ],
  }),
};

export default pageDefinition(pageDefinitionConfiguration);
